import { ReactElement, ReactNode } from 'react';

export const BillingPanel = ({
  title,
  badge,
  action,
  children,
}: {
  title: string;
  badge?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}): ReactElement => (
  <section className="rounded border border-grey-t-800">
    <header className="flex items-center justify-between gap-3 p-5 border-b border-grey-t-800">
      <div className="flex items-center gap-3">
        <h2 className="font-grotesque text-h2 leading-8 font-semibold text-white">
          {title}
        </h2>
        {badge}
      </div>
      {action && <div className="flex items-center gap-3">{action}</div>}
    </header>
    <div className="p-5 space-y-5">{children}</div>
  </section>
);
